import { FULL_WIDTH_ROUTES, HOME, SERVER_HOME } from '../constants/siteConstants';
import LocalStorageService from '../services/LocalStorage/LocalStorage.service';
import Dates from './dates';
import Session from './session';

export const getCurrentYear = () => new Date().getFullYear();

export const parseIntOrUndefined = (valueToParse) => {
  const parsedValue = parseInt(valueToParse);
  return isNaN(parsedValue) ? undefined : parsedValue;
};

export const parseFloatOrUndefined = (valueToParse) => {
  const parsedValue = parseFloat(valueToParse);
  return isNaN(parsedValue) ? undefined : parsedValue;
};

export const removeLastChar = (text, char) => {
  if (text && char && typeof text === 'string' && typeof char === 'string') {
    return text.slice(0, text.lastIndexOf(char));
  }
};

export const openStreamPDFFile = (streamPdf) => {
  //Create a Blob from the PDF Stream
  const file = new Blob([streamPdf], { type: 'application/pdf' });

  //Build a URL from the file
  const fileURL = URL.createObjectURL(file);

  //Open the URL on new Window
  window.open(fileURL);
};

// Getters HTTP request headers
export const getContentTypeHeader = (headers) => headers['Content-Type'] || headers['content-type'];

export const downloadStreamFile = (response, partialFileName) => {
  // Response data
  const headers = response?.headers;
  const streamFile = response?.data;
  const mimeType = getContentTypeHeader(headers);

  // File attributes
  const today = new Date();
  const dateString = `${today.getFullYear()}_${today.getMonth() + 1}_${today.getDate()}`;
  const fileExtension = extractFileExtensionFromContentType(mimeType);
  const fileName = `${dateString}-${partialFileName}.${fileExtension}`;

  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([streamFile], { type: mimeType });

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  link.href = data;
  link.download = fileName;
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
};

// Check if a date is valid
export const isValidDate = (dateToValidate) => {
  let retorno = false;
  if (dateToValidate) {
    const dateObj = new Date(dateToValidate);
    retorno = !isNaN(dateObj.getFullYear());
  }
  return retorno;
};

// Converts a date into strin with format 'DD/MM/YYYY'
export const dateToStringFormatedToShowARG = (dateToConvert, addTimeZone = true) => {
  let retorno;
  if (isValidDate(dateToConvert)) {
    const theDateObj = addTimeZone
      ? new Date(`${dateToConvert} 05:00:00`)
      : new Date(dateToConvert);
    const theYear = theDateObj.getFullYear();
    let theMont = (theDateObj.getMonth() + 1)?.toString();
    theMont = theMont.length == 1 ? '0' + theMont : theMont;
    let theDay = theDateObj.getDate()?.toString();
    theDay = theDay.length == 1 ? '0' + theDay : theDay;
    retorno = `${theDay}/${theMont}/${theYear}`;
  }
  return retorno;
};

// Converts a date into strin with format 'YYYY/MM/DD'
export const dateToStringFormatedToShowUSA = (dateToConvert) => {
  let retorno;
  if (isValidDate(dateToConvert)) {
    const theDateObj = new Date(dateToConvert);
    const theYear = theDateObj.getFullYear();
    let theMont = (theDateObj.getMonth() + 1)?.toString();
    theMont = theMont.length == 1 ? '0' + theMont : theMont;
    let theDay = theDateObj.getDate().toString();
    theDay = theDay.length == 1 ? '0' + theDay : theDay;
    retorno = `${theYear}-${theMont}-${theDay}`;
  }
  return retorno;
};

export const dateMontToRealMonth = (value) => {
  let retorno;
  if (!isNaN(value)) {
    value += 1;
    value = value.toString();
    retorno = value.length == 1 ? `0${value}` : value;
  }
  return retorno;
};

//Formater number in Formater Money Peso AR
export const formatterPeso = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 2,
});
export const formatterPesoOrUndefined = (num) => {
  if (!isNaN(num)) {
    let L;
    num = num.toFixed(2);
    var parts = ('' + (num < 0 ? -num : num)).split('.'),
      s = parts[0],
      i = (L = s.length),
      o = '',
      c;
    while (i--) {
      o = (i == 0 ? '' : (L - i) % 3 ? '' : '.') + s.charAt(i) + o;
    }
    return (
      (num < 0 ? '-$' : '$') +
      o +
      (parts[1] ? ',' + (parts[1].length >= 2 ? parts[1] : parts[1] + '0') : ',00')
    );
  } else {
    return undefined;
  }
};

export function cleanHtmlText(input) {
  // 1. Crear un elemento para aprovechar el parser del navegador (solo si es en browser)
  const temp = document.createElement('div');
  temp.innerHTML = input;

  // 2. Obtener solo el texto sin etiquetas HTML
  const decoded = temp.textContent || temp.innerText || '';

  return decoded.trim();
}

export const extractFileExtensionFromContentType = (mimeType) => {
  switch (mimeType) {
    case 'application/pdf': {
      return 'pdf';
    }
    case 'application/vnd.ms-excel': {
      return 'xls';
    }
    case 'image/png': {
      return 'png';
    }
    case 'image/jpeg': {
      return 'jpg';
    }
    case 'text/plain': {
      return 'txt';
    }
    default: {
      return 'txt';
    }
  }
};

export const removeAllSpaces = (value) =>
  value && typeof value === 'string' ? value.replace(/ /g, '') : undefined;

export const removeAllDots = (value) =>
  value && typeof value === 'string' ? value.replace(/[.]/g, '') : undefined;

export const removeAllDashes = (value) =>
  value && typeof value === 'string' ? value.replace(/[-]/g, '') : undefined;
export const removeAllDashesTwo = (value) =>
  value && typeof value === 'string' ? value.replace(/[_]/g, '') : undefined;

export const getFirstRecord = (records) =>
  Array.isArray(records) && records?.length > 0 ? records[0] : undefined;

export const replaceAccents = (str) => {
  if (str && str !== undefined) {
    let accents = '°´ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    let accentsOut = '  AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
    str = str.split('');
    str.forEach((letter, index) => {
      let i = accents.indexOf(letter);
      if (i != -1) {
        str[index] = accentsOut[i];
      }
    });
    return str.join('');
  }
};

export const formatDefaultIdString = (string) =>
  replaceAccents(string)?.toLowerCase().replace(/\s/g, '-');

export const isNotEmptyArray = (value) => Array.isArray(value) && value.length > 0;
export const isEmptyArray = (value) => Array.isArray(value) && value.length === 0;

export const currency = (x) => {
  let z = 0;
  if (x) {
    const y = parseFloat(x).toFixed(2).replace('.', ',');
    z = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  return z;
};

export const buildURLQuery = (params) => {
  const esc = encodeURIComponent;
  let query;
  if (params) {
    query = Object.keys(params)
      .map((key) => {
        const value = params[key];
        let dato = '';
        let url;
        if (Array.isArray(value)) {
          url = value.reduce((accumulator, item) => {
            return (accumulator += `${key}[]=${item}&`);
          }, '');
          url = removeLastChar(url, '&');
        } else if (value || value == 0) {
          dato = value;
          url = esc(key) + '=' + esc(dato);
        }
        return url;
      })
      .join('&');
  }
  return query || '';
};

export const handleImport = (path, folder = 'menuDesplegable') => {
  // This is to not throw an error in Cypress tests, in production it will work as expected
  // For testing the pdfs locally, comment the following line
  if (process.env.NODE_ENV === 'development') return '';
  return require(`../assets/${folder}/${path}`).default;
};

export const shouldShowData = () => {
  const twentyFourHours = 24 * 60 * 60 * 1000; // 24 horas en milisegundos
  const currentDate = new Date();
  const endDateMonth = new Date('2023-06-30');
  const shouldShowContent = currentDate <= endDateMonth;
  const campaignModalLastShown = LocalStorageService.get('campaignModalLastShown')
    ? LocalStorageService.get('campaignModalLastShown')
    : undefined;
  const timeDiff = currentDate.getTime() - campaignModalLastShown;
  const shouldShowDialog = timeDiff >= twentyFourHours;

  return {
    shouldShowContent,
    shouldShowDialog,
    campaignModalLastShown,
    currentDate,
  };
};

export const safeParseJSON = (jsonString) => {
  try {
    const obj = JSON.parse(jsonString);
    if (obj && typeof obj === 'object') {
      return obj;
    }
  } catch (_) {}
  return null;
};

export const sanitizeQuestionMarks = (string) => {
  return string.replace(/[?]/g, "'");
};

export const responseHasError = (response) =>
  response.some((options) => options.codigo === 'error');

export const STATUS_CODE = {
  HTTP_100_CONTINUE: 100,
  HTTP_101_SWITCHING_PROTOCOLS: 101,
  HTTP_102_PROCESSING: 102,
  HTTP_103_EARLY_HINTS: 103,
  HTTP_200_OK: 200,
  HTTP_201_CREATED: 201,
  HTTP_202_ACCEPTED: 202,
  HTTP_203_NON_AUTHORITATIVE_INFORMATION: 203,
  HTTP_204_NO_CONTENT: 204,
  HTTP_205_RESET_CONTENT: 205,
  HTTP_206_PARTIAL_CONTENT: 206,
  HTTP_207_MULTI_STATUS: 207,
  HTTP_208_ALREADY_REPORTED: 208,
  HTTP_226_IM_USED: 226,
  HTTP_300_MULTIPLE_CHOICES: 300,
  HTTP_301_MOVED_PERMANENTLY: 301,
  HTTP_302_FOUND: 302,
  HTTP_303_SEE_OTHER: 303,
  HTTP_304_NOT_MODIFIED: 304,
  HTTP_305_USE_PROXY: 305,
  HTTP_306_RESERVED: 306,
  HTTP_307_TEMPORARY_REDIRECT: 307,
  HTTP_308_PERMANENT_REDIRECT: 308,
  HTTP_400_BAD_REQUEST: 400,
  HTTP_401_UNAUTHORIZED: 401,
  HTTP_402_PAYMENT_REQUIRED: 402,
  HTTP_403_FORBIDDEN: 403,
  HTTP_404_NOT_FOUND: 404,
  HTTP_405_METHOD_NOT_ALLOWED: 405,
  HTTP_406_NOT_ACCEPTABLE: 406,
  HTTP_407_PROXY_AUTHENTICATION_REQUIRED: 407,
  HTTP_408_REQUEST_TIMEOUT: 408,
  HTTP_409_CONFLICT: 409,
  HTTP_410_GONE: 410,
  HTTP_411_LENGTH_REQUIRED: 411,
  HTTP_412_PRECONDITION_FAILED: 412,
  HTTP_413_REQUEST_ENTITY_TOO_LARGE: 413,
  HTTP_414_REQUEST_URI_TOO_LONG: 414,
  HTTP_415_UNSUPPORTED_MEDIA_TYPE: 415,
  HTTP_416_REQUESTED_RANGE_NOT_SATISFIABLE: 416,
  HTTP_417_EXPECTATION_FAILED: 417,
  HTTP_418_IM_A_TEAPOT: 418,
  HTTP_421_MISDIRECTED_REQUEST: 421,
  HTTP_422_UNPROCESSABLE_ENTITY: 422,
  HTTP_423_LOCKED: 423,
  HTTP_424_FAILED_DEPENDENCY: 424,
  HTTP_425_TOO_EARLY: 425,
  HTTP_426_UPGRADE_REQUIRED: 426,
  HTTP_428_PRECONDITION_REQUIRED: 428,
  HTTP_429_TOO_MANY_REQUESTS: 429,
  HTTP_431_REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
  HTTP_451_UNAVAILABLE_FOR_LEGAL_REASONS: 451,
  HTTP_500_INTERNAL_SERVER_ERROR: 500,
  HTTP_501_NOT_IMPLEMENTED: 501,
  HTTP_502_BAD_GATEWAY: 502,
  HTTP_503_SERVICE_UNAVAILABLE: 503,
  HTTP_504_GATEWAY_TIMEOUT: 504,
  HTTP_505_HTTP_VERSION_NOT_SUPPORTED: 505,
  HTTP_506_VARIANT_ALSO_NEGOTIATES: 506,
  HTTP_507_INSUFFICIENT_STORAGE: 507,
  HTTP_508_LOOP_DETECTED: 508,
  HTTP_509_BANDWIDTH_LIMIT_EXCEEDED: 509,
  HTTP_510_NOT_EXTENDED: 510,
  HTTP_511_NETWORK_AUTHENTICATION_REQUIRED: 511,
};

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const fullWidthRoute = (location = window.location.pathname) =>
  FULL_WIDTH_ROUTES.some(
    ({ route }) => location === HOME || location === SERVER_HOME || location.includes(route),
  );

export const prestacionFits = (prestacionesString, prestacion, prestacionesCount) => {
  var max = 255;
  var paramLength = prestacionesString.length;
  var prestacionLength = prestacion.length;
  var prestacionesCountLength = prestacionesCount.toString().length + 1; //length cantidad de prestaciones + separador ^

  return prestacionesCountLength + prestacionLength + paramLength < max;
};

export const hasMoreOfDays = (fecha, diasDiff) => {
  return Dates.get(fecha).getDifference(new Date(), 'days') < -diasDiff;
};

export const currencyFormat = (num) => {
  if (num && num.length > 0) {
    if (num.includes('-')) {
      num = num.replace('-', '');
      num = `-${num}`;
    }
  }
  return parseFloat(num);
};

export const getDifferetsIdFromArray = (array, keyToSearch) => {
  if (Array.isArray(array)) {
    const firstValueForKey = array[0][keyToSearch];
    const results = array
      .filter((ext) => ext[keyToSearch] !== firstValueForKey)
      .map((result) => result[keyToSearch]);
    results.push(firstValueForKey);

    return results.sort((a, b) => a - b);
  }
  return [];
};

export const createAQueryParam = (key, value) => {
  return `${key.toLowerCase()}=${value}`;
};

export const createQueryParams = (paramValues, paramName, withIndex = true) => {
  if (Array.isArray(paramValues)) {
    return paramValues
      .map((value, index) => {
        const key = `${paramName}${withIndex ? index + 1 : ''}`;
        return createAQueryParam(key, value);
      })
      .join('&');
  }
  return '';
};

export const getNormalizeCensuseName = (text) => {
  const options = {
    'Censos': 'Admisión a Internación',
    'CENSOS': 'INTERNACIÓN',
    'Registro de pacientes internados / Censos': 'Admisión a Internación',
    'Búsqueda de Censos': 'Búsqueda de Internaciones',
  };

  if (!options[text]) return text;

  const hospitalizationInAffiliateValidation = Session.getHospitalizationInAffiliateValidation();
  return !hospitalizationInAffiliateValidation ? text : options[text];
};
